import React, { Component, Fragment } from 'react';

import { observer } from 'mobx-react';

import { localizable } from 'components/Localization';

// props.store = AuctionFinalsStore

@localizable
@observer
export default class AuctionFinalsTotals extends Component {
  render() {
    const { store, locale, currency, t } = this.props;

    return (
      <Fragment>
        {t('Awarded')}: {store.awardedPrice.toFormattedMoney(locale, currency)}{' '}
        ({store.awardedCount}), {t('Selected')}:{' '}
        {store.selectedPrice.toFormattedMoney(locale, currency)} (
        {store.selectedCount}), {t('Total')}:{' '}
        {(store.awardedPrice + store.selectedPrice).toFormattedMoney(
          locale,
          currency
        )}{' '}
        ({store.awardedCount + store.selectedCount})
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/AuctionFinals/components/AuctionFinalsTotals.jsx